import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export interface EmptyStateProps {
  title: string;
  body: string;
  icon?: React.ReactNode;
}

/** Centered explanation used when there is nothing to show (no data yet, no access, no team). */
export const EmptyState: React.FC<EmptyStateProps> = ({ title, body, icon }) => (
  <Paper elevation={0} sx={{ p: { xs: 4, md: 6 }, textAlign: 'center', border: '1px solid', borderColor: 'divider' }}>
    {icon ? <Box sx={{ mb: 1.5, color: 'text.disabled', '& svg': { fontSize: 48 } }}>{icon}</Box> : null}
    <Typography variant="h6" gutterBottom>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 560, mx: 'auto' }}>
      {body}
    </Typography>
  </Paper>
);
